<div class="container">
  <app-sub-study-form [study]="study"></app-sub-study-form>
  <app-sub-study-scapist-list [study]="study"></app-sub-study-scapist-list>
</div>
